// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from "./locales/en/translation.json";
import hiTranslation from "./locales/hi/translation.json";

const savedLang = (): string => {
  try {
    const v = window.localStorage.getItem("ci_lang");
    return v === "hi" || v === "en" ? v : "en";
  } catch (e) {
    return "en";
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      hi: { translation: hiTranslation },
    },
    // Bhasha ka chunav browser me yaad rehta hai (LanguageToggle `ci_lang` likhta hai).
    // Pehle sirf LanguageToggle mount par restore hota tha — isliye jin pages par
    // header nahi hai (OTP, forgot-password) wahan reload par Hindi chali jaati thi.
    lng: savedLang(), // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
